import { useCallback, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLiveKit } from "../contexts";
import { endMeetingApi } from "../api/api-setting-meeting";
import { toast } from "sonner";

export const useMeetingLeave = () => {
  const navigate = useNavigate();
  const { disconnect, isHostOrCoHost, meeting } = useLiveKit();
  const [leaveDialogOpen, setLeaveDialogOpen] = useState(false);
  const [leaving, setLeaving] = useState(false);
  const busy = useRef(false);
  const performLeave = useCallback(async (endForEveryone: boolean) => {
    if (busy.current || (endForEveryone && (!isHostOrCoHost || !meeting?.id))) return;
    busy.current = true;
    setLeaving(true);
    try {
      if (endForEveryone && meeting) await endMeetingApi(meeting.id);
      await disconnect();
      setLeaveDialogOpen(false);
      navigate("/meetings");
    } catch {
      toast.error(endForEveryone ? "Không kết thúc được cuộc họp. Vui lòng thử lại." : "Không rời được phòng. Vui lòng thử lại.");
    } finally {
      busy.current = false;
      setLeaving(false);
    }
  }, [disconnect, navigate, isHostOrCoHost, meeting]);
  const handleLeave = useCallback(() => {
    if (isHostOrCoHost) setLeaveDialogOpen(true);
    else void performLeave(false);
  }, [isHostOrCoHost, performLeave]);
  return { handleLeave, leaveDialogOpen, setLeaveDialogOpen, leaving, performLeave };
};
